import { LDProvider } from 'launchdarkly-react-client-sdk';
import 'moment/min/locales';
import 'rc-slider/assets/index.css';
import React from 'react';
import { Provider } from 'react-redux';

import './config/i18n';
import './polyfills';

import { FeatureFlagsManager } from './config/FeatureFlagsManager';
import { store } from './config/rootStore';
import { LanguagePreferenceListener } from './modules/user/components/LanguagePreferenceListener';
import { Root } from './Root';
import { appInit } from './shared/actions/sharedActions';

import './shared/styles/App.less';
import './shared/styles/scss/style.scss';

store.dispatch(appInit());

export const App: React.FC = () => (
    <Provider store={store}>
        <LDProvider
            clientSideID={process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID || ''}
            user={{ anonymous: true }}
            options={{ allAttributesPrivate: true, sendEvents: false }}
        >
            <FeatureFlagsManager />
            <LanguagePreferenceListener />
            <Root />
        </LDProvider>
    </Provider>
);
